<footer class="footer">
  <div>
    <a href="https://www.gesvatec.com" target="_blank">
      &copy; {{year | date: 'yyyy'}} Gesvatec Sistemas S.L.
    </a>
  </div>
  <section>v. {{version}}</section>
</footer>
